
// "use client";

// import { useEffect, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import axios from "axios";
// import { baseUrl } from "../../config/baseUrl";
// import moment from "moment";

// const ViewStudent = () => {
//   const { id } = useParams();
//   const [bookingData, setBookingData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchStudent = async () => {
//       try {
//         const response = await axios.get(`${baseUrl}/owner/users/${id}`, {
//           headers: {
//             Authorization: localStorage.getItem("token"),
//           },
//         });
//         setBookingData(response.data?.data);
//       } catch (error) {
//         console.error("Error fetching student data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchStudent();
//   }, [id]);

//   const student = bookingData?.userId;
//   const payment = bookingData?.paymentDetails;

//   return (
//     <section className="main-sec">
//       <div className="row">
//         <div className="col-lg-12">
//           <div className="dashboard-title">
//             <h4 className="dash-head">
//               <i className="fa fa-user me-2" />
//               View Student
//             </h4>
//           </div>
//           <div className="custom-bredcump">
//             <nav aria-label="breadcrumb">
//               <ol className="breadcrumb">
//                 <li className="breadcrumb-item">
//                   <Link to="/">Dashboard</Link>
//                 </li>
//                 <li className="breadcrumb-item">
//                   <Link to="/students">Students</Link>
//                 </li>
//                 <li className="breadcrumb-item active" aria-current="page">
//                   View Student
//                 </li>
//               </ol>
//             </nav>
//           </div>
//         </div>

//         <div className="col-lg-12">
//           <div className="cards view-student">
//             <h4 className="card-title mb-5">Student Details</h4>
//             <div className="row">
//               <div className="col-lg-6 mb-4">
//                 <label className="form-label">Full Name</label>
//                 <div className="form-control">{student?.name || "N/A"}</div>
//               </div>

//               <div className="col-lg-6 mb-4">
//                 <label className="form-label">Email</label>
//                 <div className="form-control">{student?.email || "N/A"}</div>
//               </div>

//               <div className="col-lg-6 mb-4">
//                 <label className="form-label">Booking Id</label>
//                 <div className="form-control">
//                   {bookingData?.bookingId || "N/A"}
//                 </div>
//               </div>

//               <div className="col-lg-6 mb-4">
//                 <label className="form-label">Booking Status</label>
//                 <div className="form-control">
//                   {bookingData?.status || "N/A"}
//                 </div>
//               </div>

//               <div className="col-lg-6 mb-4">
//                 <label className="form-label">Start Date</label>
//                 <div className="form-control">
//                   {moment(bookingData?.startDate).format("lll") || "N/A"}
//                 </div>
//               </div>

//               <div className="col-lg-6 mb-4">
//                 <label className="form-label">End Date</label>
//                 <div className="form-control">
//                   {moment(bookingData?.endDate).format("lll") || "N/A"}
//                 </div>
//               </div>

//               <div className="col-lg-6 mb-4">
//                 <label className="form-label">Slot</label>
//                 <div className="form-control">
//                   {`${bookingData?.fromTime} - ${bookingData?.toTime} ` ||
//                     "N/A"}
//                 </div>
//               </div>

//               <div className="col-lg-6 mb-4">
//                 <label className="form-label">Payment Method</label>
//                 <div className="form-control">
//                   {bookingData?.paymentMethod || "N/A"}
//                 </div>
//               </div>

//               {/* <div className="col-lg-6 mb-4">
//                 <label className="form-label">Transaction ID</label>
//                 <div className="form-control">{payment?.transactionId || "N/A"}</div>
//               </div> */}

//               <div className="col-lg-6 mb-4">
//                 <label className="form-label">Amount Paid</label>
//                 <div className="form-control">
//                   {bookingData?.amount ? `₹${bookingData.amount}` : "N/A"}
//                 </div>
//               </div>

//               {/* <div className="col-lg-6 mb-4">
//                 <label className="form-label">Payment Gateway</label>
//                 <div className="form-control">{payment?.paymentGateway || "N/A"}</div>
//               </div> */}
//               <div className="col-lg-6 mb-4">
//                 <label className="form-label">Admin Commission (Value) </label>
//                 <div className="form-control">
//                   {bookingData?.adminCommissionValue != null
//                     ? `${bookingData.adminCommissionValue}`
//                     : "N/A"}
//                 </div>
//               </div>

//               <div className="col-lg-6 mb-4">
//                 <label className="form-label">Remaining Amount</label>
//                 <div className="form-control">
//                   {bookingData?.remainingAmount != null
//                     ? `₹${bookingData.remainingAmount}`
//                     : "N/A"}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ViewStudent;


"use client";

import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../config/baseUrl";
import moment from "moment";

const ViewStudent = () => {
  const { id } = useParams();
  const [bookingData, setBookingData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const response = await axios.get(`${baseUrl}/owner/users/${id}`, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        });
        setBookingData(response.data?.data);
      } catch (error) {
        console.error("Error fetching student data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStudent();
  }, [id]);

  const student = bookingData?.userId;
  const payment = bookingData?.paymentDetails;

  return (
    <section className="main-sec">
      <div className="row">
        <div className="col-lg-12">
          <div className="dashboard-title">
            <h4 className="dash-head">
              <i className="fa fa-user me-2" />
              View Student
            </h4>
          </div>
          <div className="custom-bredcump">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/students">Students</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  View Student
                </li>
              </ol>
            </nav>
          </div>
        </div>

        <div className="col-lg-12">
          <div className="cards view-student">
            <h4 className="card-title mb-5">Student Details</h4>
            <div className="row">
              <div className="col-lg-6 mb-4">
                <label className="form-label">Full Name</label>
                <div className="form-control">{student?.name || "N/A"}</div>
              </div>

              <div className="col-lg-6 mb-4">
                <label className="form-label">Email</label>
                <div className="form-control">{student?.email || "N/A"}</div>
              </div>

              <div className="col-lg-6 mb-4">
                <label className="form-label">Booking Id</label>
                <div className="form-control">{bookingData?.bookingId || "N/A"}</div>
              </div>

              <div className="col-lg-6 mb-4">
                <label className="form-label">Booking Status</label>
                <div className="form-control">{bookingData?.status || "N/A"}</div>
              </div>

              <div className="col-lg-6 mb-4">
                <label className="form-label">Start Date</label>
                <div className="form-control">
                  {bookingData?.startDate
                    ? moment(bookingData.startDate).format("lll")
                    : "N/A"}
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <label className="form-label">End Date</label>
                <div className="form-control">
                  {bookingData?.endDate
                    ? moment(bookingData.endDate).format("lll")
                    : "N/A"}
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <label className="form-label">Slot</label>
                <div className="form-control">
                  {bookingData?.fromTime && bookingData?.toTime
                    ? `${bookingData.fromTime} - ${bookingData.toTime}`
                    : "N/A"}
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <label className="form-label">Payment Method</label>
                <div className="form-control">{bookingData?.paymentMethod || "N/A"}</div>
              </div>

              {bookingData?.paymentMethod === "online" && (
                <>
                  <div className="col-lg-6 mb-4">
                    <label className="form-label">Transaction ID</label>
                    <div className="form-control">
                      {payment?.transactionId || "N/A"}
                    </div>
                  </div>

                  <div className="col-lg-6 mb-4">
                    <label className="form-label">Payment Gateway</label>
                    <div className="form-control">
                      {payment?.paymentGateway || "N/A"}
                    </div>
                  </div>
                </>
              )}

              <div className="col-lg-6 mb-4">
                <label className="form-label">Amount Paid</label>
                <div className="form-control">
                  {bookingData?.amount ? `₹${bookingData.amount}` : "N/A"}
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <label className="form-label">Admin Commission</label>
                <div className="form-control">
                  {bookingData?.adminCommissionValue != null
                    ? `${bookingData.adminCommissionValue}%`
                    : "N/A"}
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <label className="form-label">Remaining Amount</label>
                <div className="form-control">
                  {bookingData?.remainingAmount != null
                    ? `₹${bookingData.remainingAmount}`
                    : "N/A"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ViewStudent;
